export default "__VITE_ASSET__DkgniGR7__"